angular
  .module("appModule")
  .controller(
    "FormularioCrearComentarioGenericoController",
    FormularioCrearComentarioGenericoController
  )
  .controller(
    "FormularioEliminarComentarioGenericoController",
    FormularioEliminarComentarioGenericoController
  )

function FormularioCrearComentarioGenericoController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.comentario = ""

  self.agregarComentario = function() {
    console.log("agregar comentario")

    saveCallback(self.comentario)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

function FormularioEliminarComentarioGenericoController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.eliminar = function() {
    saveCallback()
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}
